var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_site_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-site-management"),
      filterable: "",
      exportBtn: _vm.hasBtn("export-admin-site-management"),
      importBtn: _vm.hasBtn("import-admin-site-management"),
      "import-options": {
        api: "/site/import/",
        templateUrl:
          "https://assets.essencehr.io/web/ess-business/assets/site-import-template.xlsx",
        success: function (result) {
          _vm.getList(null, 1, _vm.$tableSetting.perPageSize, function () {
            _vm.$store.dispatch("resetTable", new Date().getTime())
          })
        },
      },
    },
    on: {
      new: _vm.toNew,
      filter: function (val) {
        _vm.filterPageData = val
      },
      export: _vm.onExport,
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                "filter-page-data": _vm.filterPageData,
                showSelect: _vm.showSelect,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "table-title text--primary",
                          attrs: {
                            title: _vm.$getCommonLangValue(item.site_name),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$getCommonLangValue(item.site_name)) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "text--secondary table-subtitle",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.site_description
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(item.site_description)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.abbr",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(_vm._s(_vm.$getCommonLangValue(item.site_abbr))),
                    ]
                  },
                },
                {
                  key: "item.type",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap justify-start",
                          staticStyle: { "max-width": "400px" },
                        },
                        _vm._l(item.ess_site_type, function (type, index) {
                          return _c(
                            "v-chip",
                            {
                              key: index,
                              staticClass: "ma-1 table-title",
                              attrs: { small: "" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$getCommonLangValue(type.site_type_name)
                                )
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn("delete-admin-site-management"),
                          editBtn: _vm.hasBtn("edit-admin-site-management"),
                          viewBtn: _vm.hasBtn("view-admin-site-management"),
                          title: _vm.$t("label_essweb_site_list_title"),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }